import { Box } from '@chakra-ui/react'

export const SectionBody = ({
  children,
  isOpened = false,
}: {
  children?: React.ReactNode
  isOpened?: boolean
}) => {
  return isOpened ? <Box sx={{ bg: 'white' }}>{children && children}</Box> : null
}
